import { createTheme } from '@mui/material/styles';
import { CommonThemeOptions } from './commonTheme';
import type { IThemeOptions } from './index';

export const Piano2NotesOptions: IThemeOptions = {
  ...CommonThemeOptions,
  themeName: 'Piano2Notes',
  components: {
    ...CommonThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: {
          color: '#3b8daa',
          '&.Mui-disabled': {
            color: '#255d70',
            border: '1px solid #255d70',
          },
        },
        containedPrimary: {
          backgroundColor: '#3b8daa',
          '&.Mui-disabled': {
            backgroundColor: '#255d70',
            color: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          color: '#fff',
          backgroundColor: '#3b8daa',
          background: '#3b8daa',
          '&.Mui-disabled': {
            background: '#caced133',
            color: '#ffffff42',
          },
        },
      },
    },
  },
  palette: {
    ...CommonThemeOptions.palette,
    primary: {
      main: '#3b8daa',
      light: '#8ed0f5',
      dark: '#255d70',
      contrastText: '#fff',
    },
  },
};

export const Piano2NotesTheme = createTheme(Piano2NotesOptions);
